import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {
  IClient,
  IClientCreateResponse,
  IClientDeleteResponse,
  IClientNamesResponse,
  IClientUpdateResponse,
  IClientUpdateStatusResponse,
  IListClientResponse,
  IListClientsRequestBody,
} from '../../state/models/client.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private readonly clientBaseUrl = `${environment.clientEndpoint}/api/client`;

  constructor(private readonly apiService: ApiService) {}

  createClient(client: Omit<IClient, 'id'>): Promise<IClientCreateResponse> {
    return this.apiService.post<IClientCreateResponse>(
      `${this.clientBaseUrl}/`,
      client
    );
  }

  getClientById(id: number): Promise<{ data: IClient }> {
    return this.apiService.get<{ data: IClient }>(
      `${this.clientBaseUrl}/${id}`
    );
  }

  listClients(
    body: IListClientsRequestBody,
    page = 1,
    limit = 10
  ): Promise<IListClientResponse> {
    return this.apiService.post<IListClientResponse>(
      `${this.clientBaseUrl}/list?page=${page}&limit=${limit}`,
      body
    );
  }

  listClientNames(): Promise<IClientNamesResponse> {
    return this.apiService.get<IClientNamesResponse>(
      `${this.clientBaseUrl}/get-clients-list/active`,
      {}
    );
  }

  listAllStatusClientNames(): Promise<IClientNamesResponse> {
    return this.apiService.get<IClientNamesResponse>(
      `${this.clientBaseUrl}/get-clients-list/all`,
      {}
    );
  }

  updateClient(
    id: number,
    client: Partial<IClient>
  ): Promise<IClientUpdateResponse> {
    return this.apiService.put<IClientUpdateResponse>(
      `${this.clientBaseUrl}/${id}`,
      client
    );
  }

  deleteClient(id: number): Promise<IClientDeleteResponse> {
    return this.apiService.delete<IClientDeleteResponse>(
      `${this.clientBaseUrl}/${id}`
    );
  }

  changeClientStatus(id: number): Promise<IClientUpdateStatusResponse> {
    return this.apiService.patch<IClientUpdateStatusResponse>(
      `${this.clientBaseUrl}/${id}`,
      {}
    );
  }
}
